import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import {Inject, Injectable} from '@angular/core';
import { SecureApi } from '../../core/secure.api';
import { ENV } from '../../app.env';
import { KlenicoMeService } from '../me.service';
import { AppService } from '../../app.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class MeDashboardService extends KlenicoMeService{
    SECTION = 'process';
    showPredictionCard = true;

    constructor(
        public http: HttpClient,
        public secureApi: SecureApi,
        @Inject('baseUrl') public baseUrl: string,
        @Inject('storyBlokAPI') public storyBlokAPI: string,
        @Inject('storyBlokToken') public storyBlokToken: string,
        public appService: AppService,
        public translateService: TranslateService,
    ) {
        super(secureApi, appService, translateService, http, storyBlokToken, storyBlokAPI);
        this.COMPONENT = 'dashboard';
    }

    getSBDashboard(language) {
        let lang = language.split('_')[0];
        let url = this.getStoryBlokAPI() + this.SECTION + '?token=' + this.storyBlokToken + '&language=' + lang + '&resolve_links=url';
        return this.http.get(url);
    }

    getDocuments() {
        return this.secureApi.get('patient/get-document');
    }

}
